import {
  FormControl,
  InputLabel,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { useSearchContext } from "../../../contexts/SearchContext";
import { useCategories } from "../../../hooks/queries/useCategories";
import { FilterSelect } from "./FilterSelect";

interface ProductType {
  cod: string;
  description: string;
}

const FilterProductType = () => {
  const {
    searchProductType,
    setSearchProductType,
    setSearchCategoryGroup,
    setSearchCategory,
  } = useSearchContext();
  const { data: categories = [] } = useCategories();

  const productsTypes: ProductType[] = Object.values(
    categories.reduce<Record<string, ProductType>>((acc, category) => {
      if (!acc[category.cod_type] && category.type) {
        acc[category.cod_type] = {
          cod: category.cod_type,
          description: category.type,
        };
      }

      return acc;
    }, {})
  );

  const onChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value !== "0" ? event.target.value : "*";

    setSearchProductType(value);
    setSearchCategoryGroup("*");
    setSearchCategory("*");
  };

  return (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel>Tipo:</InputLabel>
      <FilterSelect value={searchProductType} onChange={onChange} label="Tipo">
        <MenuItem value="*">Todas as opções</MenuItem>
        {productsTypes.map(productType => (
          <MenuItem
            key={productType.cod}
            value={productType.cod}
            selected={searchProductType === productType.cod}
          >
            {productType.description}
          </MenuItem>
        ))}
      </FilterSelect>
    </FormControl>
  );
};

export default FilterProductType;
